/** Yellow Time Remaining chrome when fewer than 5:00 remain in that section. Default off. */

export function isPearsonTimeRemainingWarning(seconds, { enabled } = {}) {
  if (!enabled) return false;
  const value = Number(seconds);
  return Number.isFinite(value) && value > 0 && value < 300;
}

export function shouldPausePearsonTimerOnHelp() {
  return false;
}

/** Help must not pause. Always tick remaining time down by one second. */
export function tickPearsonLocalCountdown(secondsLeft, { helpOpen } = {}) {
  void helpOpen;
  const value = Number(secondsLeft);
  if (!Number.isFinite(value) || value <= 0) return 0;
  return value - 1;
}
